import { render, staticRenderFns } from "./reportFunctionDetails.vue?vue&type=template&id=0d8bf044&scoped=true&"
import script from "./reportFunctionDetails.vue?vue&type=script&lang=js&"
export * from "./reportFunctionDetails.vue?vue&type=script&lang=js&"
import style0 from "./reportFunctionDetails.vue?vue&type=style&index=0&id=0d8bf044&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8bf044",
  null
  
)

export default component.exports